<script setup>
const props = defineProps({
  text: {
    type: String,
    default: `\u00A0`,
  },
  forId: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  help: {
    type: String,
    default: null,
  },
});
</script>

<template>
  <div class="sy-label-wrap" :class="size">
    <label :for="props.forId" class="sy-label">
      <slot v-if="$slots.default"></slot>
      <template v-else>{{ props.text }}</template>
    </label>
    <template v-if="props.help">
      <i v-tooltip.top="props.help" class="pi pi-question-circle sy-label-tooltip-icon"></i>
    </template>
    <div v-if="props.required" class="sy-required"></div>
    <slot name="action"></slot>
    <div class="spacer"></div>
    <slot name="actionRight"></slot>
  </div>
</template>